export function registerBinding(bindingName, bindingObject) {
  ko.bindingHandlers[bindingName] = bindingObject;
}

export function registerBindings(bindings) {
	Object.entries(bindings).forEach(([key, value]) =>
		registerBinding(key, value)
	);
}